import React, { useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AppstoreOutlined,
  ContactsOutlined,
  DashboardOutlined,
  DollarOutlined,
  FolderOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  LayoutOutlined,
  LogoutOutlined,
  ReadOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Menu, Space } from "antd";
import { useAuth } from "@/Context/AuthContext";
import { UserContext } from "../Context/UserContext";

function NavigationMenu({ setUseEffectCompleted, setIsNavigationVisible }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState(location.pathname);
  const { logout } = useAuth();
  const { userProfileData } = useContext(UserContext);

  const handleLogout = () => {
    logout();
  };

  const menu = [
    {
      label: "Home",
      icon: HomeOutlined,
      destination: "/home",
    },
    {
      label: "Dashboard",
      icon: DashboardOutlined,
      destination: "/home",
    },
    {
      label: "Events",
      icon: AppstoreOutlined,
      destination: "/events",
    },
    {
      label: "Pricing",
      icon: DollarOutlined,
      destination: "/pricing",
    },
    {
      label: "Settings",
      icon: SettingOutlined,
      destination: "/settings",
    },
    {
      label: "About Us",
      icon: InfoCircleOutlined,
      destination: "/about",
    },
  ];

  const handleClick = useCallback((item) => {
    navigate(item.destination);
    setSelected(item.destination);

    setIsNavigationVisible(false);
    setUseEffectCompleted(false);
  }, []);

  useEffect(() => {
    const selectedItem = menu.find((item) => {
      return location.pathname.startsWith(item.destination);
    });
    setSelected(selectedItem?.destination);
  }, [location]);
  const menuItems = [
    ...menu.map((item) => ({
      key: item.destination,
      icon: React.createElement(item.icon),
      label: item.label,
      onClick: () => handleClick(item),
    })),
    {
      key: "logout",
      icon: React.createElement(LogoutOutlined),
      label: "Log Out",
      onClick: handleLogout,
    },
  ];

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Menu mode="vertical" selectedKeys={[selected]} items={menuItems} style={{ width: "100%" }} />
    </Space>
  );
}

export default NavigationMenu;
